import { useCompanyFeatures } from './useCompanyFeatures';
/**
 * This component will render its children if the company has the feature available for the company.
 * A fallback to render can be provided if the feature is not available.
 */
export function CompanyFeatureAvailable(props) {
    const { feature, children, fallback } = props;
    const { isFeatureAvailable } = useCompanyFeatures();
    if (!isFeatureAvailable(feature)) {
        return fallback || null;
    }
    return children;
}
